import React, { useRef, useCallback } from "react";
import { useDrop } from "react-dnd";
import { RootRef } from "@material-ui/core";

import {
  ITEM_TYPES,
  CARD_TYPES,
  CARD_CONTAINER_TYPE,
} from "features/planner/planner.constants";

import RowCard from "./Card/RowCard";

const DraggableCardTarget = ({
  cardId,
  disabled,
  cardType,
  onCardMove,
  slotNo: targetSlotNo,
  groupId: targetGroupId,
  cardContainerId: targetCardContainerId,
  cardContainerType: targetCardContainerType,
  setAnchorEl,
  setAnchorElSlotNo,
}) => {
  const canDropCard = useCallback(
    item => {
      if (disabled) return false;

      const sourceCardContainerType = item.cardContainerType;

      const hasConflictingCard =
        cardId && cardId.toString() !== item.id.toString();

      if (hasConflictingCard) {
        if (cardType === CARD_TYPES.EMPLOYEE) {
          return false;
        }
      }

      if (item.cardType === CARD_TYPES.DUMMY) return true;

      if (
        sourceCardContainerType === CARD_CONTAINER_TYPE.ONSHORE &&
        targetCardContainerType === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE
      ) {
        return false;
      }

      if (
        sourceCardContainerType === CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE &&
        targetCardContainerType === CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE
      ) {
        return false;
      }

      if ((hasConflictingCard && cardType === CARD_TYPES.DUMMY) || !cardId) {
        return true;
      }

      return item.id.toString() === cardId.toString();
    },
    [disabled, cardId, targetCardContainerType, cardType],
  );

  const ref = useRef(null);

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: ITEM_TYPES.CARD,
    drop: item => {
      if (
        item.slotNo !== targetSlotNo ||
        item.cardContainerId !== targetCardContainerId
      ) {
        onCardMove({
          cardId: item.id,
          sourceSlotNo: item.slotNo,
          sourceCardContainerId: item.cardContainerId,
          sourceGroupId: item.groupId,
          targetSlotNo,
          targetCardContainerId,
          targetGroupId,
        });
      }
    },
    canDrop: canDropCard,
    collect: monitor => {
      const isOver = monitor.isOver();

      return {
        isOver,
        canDrop: isOver ? monitor.canDrop() : false, // avoid unnecessary renders
      };
    },
  });

  return (
    <RootRef rootRef={drop(ref)}>
      <RowCard
        isOver={isOver}
        cardId={cardId}
        groupId={targetGroupId}
        canDrop={canDrop}
        slotNo={targetSlotNo}
        cardContainerId={targetCardContainerId}
        setAnchorEl={setAnchorEl}
        setAnchorElSlotNo={setAnchorElSlotNo}
      />
    </RootRef>
  );
};

export default DraggableCardTarget;
